/*********************** Custom JS for Boost AI Search & Discovery  ************************/

// ===== Override Products Per Page (24 = 4 cols × 6 rows) =====
(function() {
  function overrideBoostLimit() {
    var cfg = window.boostWidgetIntegration && window.boostWidgetIntegration.config;
    if (!cfg) return;
    if (cfg.templateSettings && cfg.templateSettings.themeSettings && cfg.templateSettings.themeSettings.productList) {
      cfg.templateSettings.themeSettings.productList.productsPerPage = 24;
    }
    // Also patch defaultParams.limit in case it was already copied over
    var integration = window.boostWidgetIntegration.integration;
    if (integration && integration.defaultParams) {
      integration.defaultParams.limit = 24;
    }
  }
  overrideBoostLimit();
  document.addEventListener('boost-sd-init-start', overrideBoostLimit, { capture: true });
})();

// ===== Style Filter Icon Swatches =====
(function() {
  // Hardcoded icon mapping - will try window.styleFilterIcons first, then fallback
  const iconMap = {
    'sandal': 'Sandals.webp',
    'sandals': 'Sandals.webp',
    'sandalen': 'Sandals.webp',
    'slides': 'Slides.webp',
    'slipper': 'Slippers.webp',
    'slippers': 'Slippers.webp',
    'sneaker': 'Sneakers.webp',
    'sneakers': 'Sneakers.webp',
    'toe posts': 'Toe-posts.webp',
    'toe post': 'Toe-posts.webp',
    'toepost': 'Toe-posts.webp',
    'teenslippers': 'Toe-posts.webp'
  };

  const typeLabels = window.theme?.strings?.productTypeLabels || {};
  const captionMap = {
    'sandal': typeLabels.sandal || 'Sandals',
    'sandals': typeLabels.sandal || 'Sandals',
    'sandalen': typeLabels.sandal || 'Sandals',
    'slipper': typeLabels.slipper || 'Slippers',
    'slippers': typeLabels.slipper || 'Slippers',
    'sneaker': typeLabels.sneaker || 'Sneakers',
    'sneakers': typeLabels.sneaker || 'Sneakers',
    'toe post': typeLabels.toePost || window.theme?.strings?.toePostLabel || 'Toe posts',
    'toe posts': typeLabels.toePost || window.theme?.strings?.toePostLabel || 'Toe posts',
    'toepost': typeLabels.toePost || window.theme?.strings?.toePostLabel || 'Toe posts',
    'teenslippers': typeLabels.toePost || window.theme?.strings?.toePostLabel || 'Toe posts'
  };

  function getCaption(value) {
    return captionMap[String(value || '').trim().toLowerCase()] || null;
  }

  function getIconUrl(styleName) {
    // Try 1: Use pre-defined URLs from theme.liquid if available
    if (typeof window.styleFilterIcons !== 'undefined' && window.styleFilterIcons[styleName]) {
      return window.styleFilterIcons[styleName];
    }

    // Try 2: Construct URL using Shopify CDN pattern
    const iconFile = iconMap[styleName];
    if (iconFile) {
      // Get base URL from any existing asset or use pattern
      const scripts = document.querySelectorAll('script[src*="boost-sd-custom"]');
      if (scripts.length > 0) {
        const scriptSrc = scripts[0].src;
        const baseUrl = scriptSrc.substring(0, scriptSrc.lastIndexOf('/') + 1);
        return baseUrl + iconFile;
      }

      // Fallback: Try common Shopify asset paths
      const shopDomain = window.Shopify?.shop || window.location.hostname;
      return `//cdn.shopify.com/s/files/1/0925/3234/3117/t/4/assets/${iconFile}`;
    }

    return null;
  }

  function addStyleIcons() {
    // Get ALL style filter instances (Boost renders separate ones for desktop/mobile)
    const styleFilters = document.querySelectorAll('#pf_pt_type, [data-filteroptionid="pf_pt_type"]');

    if (styleFilters.length === 0) {
      return;
    }

    // Process each filter instance
    styleFilters.forEach(container => {
      const options = container.querySelectorAll('.boost-sd__filter-option-item');

      options.forEach(option => {
      // Skip if already processed
      if (option.dataset.styleIconAdded === 'true') return;

      const label = option.querySelector('.boost-sd__filter-option-item-label');
      if (!label) {
        option.dataset.styleIconAdded = 'true';
        return;
      }

      const rawStyleName = label.textContent.trim();
      const styleName = rawStyleName.toLowerCase();
      const iconUrl = getIconUrl(styleName);
      const caption = getCaption(styleName);
      if (caption) {
        label.textContent = caption;
      }

      if (iconUrl) {
        const button = option.querySelector('.boost-sd__filter-option-item-button');
        if (button) {
          // Check if img already exists
          if (button.querySelector('img.style-swatch-icon')) {
            option.dataset.styleIconAdded = 'true';
            return;
          }

          const img = document.createElement('img');
          img.src = iconUrl;
          img.alt = caption || rawStyleName;
          img.className = 'style-swatch-icon';
          img.loading = 'lazy';

          // Handle load errors
          img.onerror = function() {
            console.warn('[StyleIcons] Failed to load:', iconUrl);
            this.style.display = 'none';
          };

          // Copy data-action from button to img for click handling
          const dataAction = button.getAttribute('data-action');
          if (dataAction) {
            img.setAttribute('data-action', dataAction);
          }

          button.insertBefore(img, button.firstChild);
        }
      }
      option.dataset.styleIconAdded = 'true';
      });
    });
  }

  function updateRefineByCaptions() {
    const refineValues = document.querySelectorAll(
      '.boost-sd__refine-by-vertical-refine-by-value, .boost-sd__refine-by-horizontal-refine-by-value'
    );

    refineValues.forEach(value => {
      const caption = getCaption(value.textContent);
      if (caption) {
        value.textContent = caption;
      }
    });
  }

  function updateStyleFilterUi() {
    addStyleIcons();
    updateRefineByCaptions();
  }

  // Debounce function to prevent excessive calls
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  const debouncedUpdateStyleFilterUi = debounce(updateStyleFilterUi, 20);

  // MutationObserver for dynamically loaded filters
  const observer = new MutationObserver((mutations) => {
    // Check if any mutations affect the filter area
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        // Use requestAnimationFrame for immediate insertion before next paint
        requestAnimationFrame(updateStyleFilterUi);
        break;
      }
    }
  });

  function init() {
    observer.observe(document.body, { childList: true, subtree: true });
    updateStyleFilterUi();

    // Also run after a delay to catch late-loading filters
    setTimeout(updateStyleFilterUi, 500);
    setTimeout(updateStyleFilterUi, 1000);
    setTimeout(updateStyleFilterUi, 2000);
  }

  // Start observing when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Boost-specific event listeners for filter re-renders
  document.addEventListener('boost-sd-update-filter-tree', debouncedUpdateStyleFilterUi);
  document.addEventListener('boost-sd-init-start', function() {
    setTimeout(updateStyleFilterUi, 100);
    setTimeout(updateStyleFilterUi, 300);
  });
  document.addEventListener('boost-sd-init-done', debouncedUpdateStyleFilterUi);

  // Also listen for any Boost widget events
  document.addEventListener('boost-sd-filter-change', debouncedUpdateStyleFilterUi);
  document.addEventListener('boost-sd-collection-loaded', debouncedUpdateStyleFilterUi);

  // Expose for debugging
  window._debugStyleIcons = {
    addStyleIcons: addStyleIcons,
    updateRefineByCaptions: updateRefineByCaptions,
    getIconUrl: getIconUrl
  };
})();

// ===== Custom Color Swatch Tooltips =====
// Replaces slow native browser tooltips with instant CSS tooltips
(function() {
  const colorLabelMap = {
    'aqua': 'Aqua',
    'beige': 'Beige',
    'black': 'Black',
    'blush': 'Blush',
    'blozen': 'Blush',
    'chocolate': 'Chocolate',
    'chocolade': 'Chocolate',
    'graphite': 'Graphite',
    'grafiet': 'Graphite',
    'hot-pink': 'Hot Pink',
    'felroze': 'Hot Pink',
    'khaki': 'Khaki',
    'kaki': 'Khaki',
    'lavender': 'Lavender',
    'lavendel': 'Lavender',
    'midnight-blue': 'Midnight Blue',
    'natural': 'Natural',
    'natuurlijk': 'Natural',
    'peach-pink': 'Peach Pink',
    'rose': 'Rose',
    'sand': 'Sand',
    'zand': 'Sand',
    'seagrass': 'Seagrass',
    'zeegras': 'Seagrass',
    'silver': 'Silver',
    'white': 'White',
    'wit': 'White',
    'zwart': 'Black'
  };

  function normalizeKey(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function englishColor(value) {
    return colorLabelMap[normalizeKey(value)] || value;
  }
  function extractColorName(title) {
    // Parse "Find product with Color is Black" → "Black"
    const match = title.match(/is\s+(.+)$/i);
    return englishColor(match ? match[1].trim() : title);
  }

  function setupColorTooltips() {
    const swatchItems = document.querySelectorAll('.boost-sd__filter-option-swatch-item:not([data-tooltip-processed])');

    swatchItems.forEach(item => {
      const button = item.querySelector('button[title]');
      if (button && button.title) {
        const colorName = extractColorName(button.title);
        item.setAttribute('data-tooltip', colorName);
        button.removeAttribute('title'); // Remove native tooltip
      }
      item.setAttribute('data-tooltip-processed', 'true');
    });
  }

  // Debounce to prevent excessive calls
  let tooltipTimeout;
  function debouncedSetupTooltips() {
    clearTimeout(tooltipTimeout);
    tooltipTimeout = setTimeout(setupColorTooltips, 20);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupColorTooltips);
  } else {
    setupColorTooltips();
  }

  // MutationObserver for dynamically loaded filters
  const tooltipObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        requestAnimationFrame(setupColorTooltips);
        break;
      }
    }
  });

  tooltipObserver.observe(document.body, { childList: true, subtree: true });

  // Boost-specific events
  document.addEventListener('boost-sd-update-filter-tree', debouncedSetupTooltips);
  document.addEventListener('boost-sd-init-done', debouncedSetupTooltips);
  document.addEventListener('boost-sd-filter-change', debouncedSetupTooltips);
  document.addEventListener('boost-sd-collection-loaded', debouncedSetupTooltips);

  // Fallback timeouts for late-loading filters
  setTimeout(setupColorTooltips, 500);
  setTimeout(setupColorTooltips, 1000);
})();

// ===== Keep product model/color display in English =====
// Some translated markets can localize product titles and color option values.
// Product handles remain stable English, so use them as the display source.
(function() {
  const modelLabelMap = {
    'chill': 'Chill',
    'cloudnine': 'Cloudnine',
    'coastal': 'Coastal',
    'connie': 'Connie',
    'laze': 'Laze',
    'levitate': 'Levitate',
    'offshore': 'Offshore',
    'pointbreak': 'Pointbreak',
    'skyhigh': 'Skyhigh',
    'solace': 'Solace',
    'soleseeker': 'Soleseeker',
    'sundreamer': 'Sundreamer',
    'sundrifter': 'Sundrifter'
  };

  const colorLabelMap = {
    'aqua': 'Aqua',
    'beige': 'Beige',
    'black': 'Black',
    'blush': 'Blush',
    'blozen': 'Blush',
    'chocolate': 'Chocolate',
    'chocolade': 'Chocolate',
    'graphite': 'Graphite',
    'grafiet': 'Graphite',
    'hot-pink': 'Hot Pink',
    'felroze': 'Hot Pink',
    'khaki': 'Khaki',
    'kaki': 'Khaki',
    'lavender': 'Lavender',
    'lavendel': 'Lavender',
    'midnight-blue': 'Midnight Blue',
    'natural': 'Natural',
    'natuurlijk': 'Natural',
    'peach-pink': 'Peach Pink',
    'rose': 'Rose',
    'sand': 'Sand',
    'zand': 'Sand',
    'seagrass': 'Seagrass',
    'zeegras': 'Seagrass',
    'silver': 'Silver',
    'white': 'White',
    'wit': 'White',
    'zwart': 'Black'
  };

  function normalizeKey(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function titleCaseSlug(slug) {
    return String(slug || '').split('-').filter(Boolean).map(function(part) {
      return part.charAt(0).toUpperCase() + part.slice(1);
    }).join(' ');
  }

  function labelsFromHandle(handle) {
    handle = normalizeKey(handle);
    if (!handle) return null;
    const parts = handle.split('-');
    const modelSlug = parts.shift();
    const colorSlug = parts.join('-');
    const model = modelLabelMap[modelSlug] || titleCaseSlug(modelSlug);
    const color = colorLabelMap[colorSlug] || titleCaseSlug(colorSlug);
    return { model: model, color: color, title: model + ' - ' + color };
  }

  function handleFromUrl(url) {
    const match = String(url || '').match(/\/products\/([^?#/]+)/);
    return match ? match[1] : '';
  }

  function normalizeProductCards() {
    document.querySelectorAll('.boost-sd__product-info').forEach(function(info) {
      const link = info.querySelector('a[href*="/products/"]') || info.closest('.boost-sd__product-item, .boost-sd__product')?.querySelector('a[href*="/products/"]');
      const labels = labelsFromHandle(handleFromUrl(link && link.getAttribute('href')));
      if (!labels) return;

      const titleEl = info.querySelector('.boost-sd__product-title');
      if (titleEl && titleEl.textContent.trim() !== labels.model) {
        titleEl.textContent = labels.model;
      }

      let colorEl = info.querySelector('.boost-sd__product-color');
      if (!colorEl && labels.color) {
        colorEl = document.createElement('div');
        colorEl.className = 'boost-sd__product-color';
        if (link && link.parentNode === info) {
          link.insertAdjacentElement('afterend', colorEl);
        } else if (titleEl && titleEl.parentNode) {
          titleEl.parentNode.insertAdjacentElement('afterend', colorEl);
        } else {
          info.insertBefore(colorEl, info.querySelector('.boost-sd__product-price, .boost-sd__product-stars') || null);
        }
      }
      if (colorEl && colorEl.textContent.trim() !== labels.color) {
        colorEl.textContent = labels.color;
      }

      const productItem = info.closest('.boost-sd__product-item, .boost-sd__product');
      const scope = productItem || info.parentElement || info;
      scope.querySelectorAll('a[href*="/products/"], img[alt]').forEach(function(el) {
        if (el.hasAttribute('aria-label')) el.setAttribute('aria-label', labels.title);
        if (el.hasAttribute('alt')) el.setAttribute('alt', labels.title);
      });
    });
  }

  function normalizeFilterText() {
    document.querySelectorAll('.boost-sd__filter-option-item-label, .boost-sd__refine-by-vertical-refine-by-value, .boost-sd__refine-by-horizontal-refine-by-value').forEach(function(el) {
      const english = colorLabelMap[normalizeKey(el.textContent)];
      if (english) el.textContent = english;
    });
  }

  function normalizeBoostEnglish() {
    normalizeProductCards();
    normalizeFilterText();
  }

  let normalizeTimeout;
  function debouncedNormalizeBoostEnglish() {
    clearTimeout(normalizeTimeout);
    normalizeTimeout = setTimeout(normalizeBoostEnglish, 20);
  }

  const observer = new MutationObserver(function(mutations) {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0 || mutation.type === 'characterData') {
        requestAnimationFrame(normalizeBoostEnglish);
        break;
      }
    }
  });

  function init() {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    normalizeBoostEnglish();
    setTimeout(normalizeBoostEnglish, 250);
    setTimeout(normalizeBoostEnglish, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('boost-sd-update-filter-tree', debouncedNormalizeBoostEnglish);
  document.addEventListener('boost-sd-init-done', debouncedNormalizeBoostEnglish);
  document.addEventListener('boost-sd-filter-change', debouncedNormalizeBoostEnglish);
  document.addEventListener('boost-sd-collection-loaded', debouncedNormalizeBoostEnglish);
})();

// ===== Short-page sidebar fix =====
// On pages with few products, Boost SD never uses position:fixed — it goes
// straight to position:absolute which scrolls the sidebar above the header.
// Detect this case and force-fix the sidebar below the header.
// Long pages: Boost SD uses position:fixed first, then switches to absolute
// near the footer (to avoid overlapping it) — we leave that alone.
(function() {
  // Skip homepage FCF — sidebar should scroll with the section
  if (document.querySelector('.featured-collection-filter')) return;

  var HEADER = 70;
  var sidebar = null;
  var hasBeenFixed = false;
  var isForceFixed = false;
  var footer = null;

  function capHeight() {
    if (!isForceFixed) return;
    if (!footer) footer = document.querySelector('.site-footer');
    if (!footer) return;
    var footerTop = footer.getBoundingClientRect().top;
    var maxH = Math.min(window.innerHeight - HEADER, Math.max(200, footerTop - HEADER));
    sidebar.style.setProperty('max-height', maxH + 'px', 'important');
  }

  function update() {
    var style = sidebar.getAttribute('style') || '';
    if (style.indexOf('position: fixed') !== -1) {
      hasBeenFixed = true;
      if (isForceFixed) {
        sidebar.classList.remove('boost-sd--force-fixed');
        isForceFixed = false;
      }
    } else if (style.indexOf('position: absolute') !== -1 && !hasBeenFixed) {
      if (!isForceFixed) {
        sidebar.classList.add('boost-sd--force-fixed');
        isForceFixed = true;
      }
      capHeight();
    } else {
      if (isForceFixed) {
        sidebar.classList.remove('boost-sd--force-fixed');
        isForceFixed = false;
      }
    }
  }

  function onScroll() {
    if (isForceFixed) capHeight();
  }

  function init() {
    if (sidebar) return;
    sidebar = document.querySelector('.boost-sd__filter-tree-vertical-content');
    if (!sidebar) return;
    new MutationObserver(update).observe(sidebar, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // Boost SD creates elements asynchronously — poll until found
  var attempts = 0;
  var poll = setInterval(function() {
    init();
    if (sidebar || ++attempts > 40) clearInterval(poll);
  }, 200);

  document.addEventListener('boost-sd-init-done', function() { setTimeout(init, 100); });
})();

// ===== Force "Most popular" active in sort dropdown =====
// We intercept sort=best-selling → sort=manual in theme.liquid so products follow each
// collection's manual order. But Boost SD's internal state tracks "manual" and leaves
// the sort dropdown label empty. This patch cosmetically fixes it via polling.
(function() {

  function fixSortDropdown() {
    var valueEl = document.querySelector('.boost-sd__sorting-value');
    if (!valueEl) return false;
    if (valueEl.textContent.trim()) return true; // already set by Boost SD
    var bestSellingOpt = document.querySelector('.boost-sd__sorting-option[data-value="best-selling"]');
    if (!bestSellingOpt) return false;
    var label = bestSellingOpt.querySelector('.boost-sd__sorting-option-item');
    if (!label) return false;
    valueEl.textContent = label.textContent.trim();
    bestSellingOpt.classList.add('boost-sd__sorting-option--active');
    return true;
  }

  var attempts = 0;
  var poll = setInterval(function() {
    var done = fixSortDropdown();
    if (done || ++attempts > 40) clearInterval(poll);
  }, 100);
})();

// ===== Homepage FCF "View more" reveal (8 → 16) =====
// Boost fetches 16 products on the homepage (limit interceptor in theme.liquid).
// CSS shows the first 8; clicking "View more" adds .fcf-revealed to reveal the rest.
// On any Boost re-render (filter/sort change) we collapse back to 8 and re-evaluate
// the button. A product "signature" guards the MutationObserver so our own class/
// attribute toggles don't trigger a false reset (which would undo the reveal).
(function() {
  var section = document.querySelector('#FCFSection');
  if (!section) return; // homepage FCF only

  var STEP = 8;
  var lastSig = null;

  function moreButton() {
    return section.querySelector('.fcf-view-more');
  }

  function allButton() {
    return section.querySelector('.fcf-view-all');
  }

  function itemCount() {
    return section.querySelectorAll('.boost-sd__product-item').length;
  }

  // Count + first product href — changes only on a real Boost re-render,
  // not when we toggle .fcf-revealed or the button's hidden attribute.
  function signature() {
    var first = section.querySelector('.boost-sd__product-item a[href]');
    return itemCount() + '|' + (first ? first.getAttribute('href') : '');
  }

  function syncButtons() {
    var more = moreButton();
    var all = allButton();
    var collapsed = !section.classList.contains('fcf-revealed');
    var count = itemCount();
    var moreVisible = collapsed && count > STEP;
    if (more) more.hidden = !moreVisible;
    // "View all" (full-shop link) replaces "View more" when there's nothing left to
    // reveal in place: either the grid is already expanded, or a filter narrowed the
    // results to ≤8. Gate on count > 0 so it never flashes before products render.
    if (all) all.hidden = !(count > 0 && !moreVisible);
  }

  function reveal() {
    section.classList.add('fcf-revealed');
    syncButtons();
  }

  function reset() {
    section.classList.remove('fcf-revealed');
    syncButtons();
  }

  // Delegated click — survives Boost re-rendering the grid
  section.addEventListener('click', function(e) {
    if (e.target.closest('.fcf-view-more')) {
      e.preventDefault();
      reveal();
    }
  });

  var t;
  function onMaybeRerender() {
    clearTimeout(t);
    t = setTimeout(function() {
      var sig = signature();
      if (sig === lastSig) return; // no real product change — ignore our own DOM edits
      lastSig = sig;
      reset();
    }, 30);
  }

  new MutationObserver(onMaybeRerender).observe(section, { childList: true, subtree: true });

  document.addEventListener('boost-sd-collection-loaded', onMaybeRerender);
  document.addEventListener('boost-sd-filter-change', onMaybeRerender);
  document.addEventListener('boost-sd-init-done', onMaybeRerender);

  // Initial passes (Boost renders async)
  lastSig = signature();
  syncButtons();
  setTimeout(function() { lastSig = signature(); syncButtons(); }, 600);
  setTimeout(function() { lastSig = signature(); syncButtons(); }, 1500);
})();
